import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Typography } from '@mui/material';
import { Formik } from 'formik';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import { useNavigate } from 'react-router-dom';

const EscalatedModal: React.FC<Props> = React.forwardRef(
    ({ callbackClosingModal, callbackOpenModal }, ref): React.ReactElement => {
        const [reason, setReason] = React.useState<string>('');
        const [open, setOpen] = React.useState(false);
        const [isActiveBackNavigation, setActiveBackNavigation] =
            React.useState<boolean>(false);
        const navigation = useNavigate();
        const handleOpen = React.useCallback((): void => {
            setOpen(true);
            if (typeof callbackOpenModal === 'function') callbackOpenModal();
        }, []);
        const handleClose = React.useCallback((): void => {
            setOpen(false);
            if (typeof callbackClosingModal === 'function')
                callbackClosingModal(null);
        }, []);
        React.useImperativeHandle(
            ref,
            () => ({
                setClose: () => {
                    handleClose();
                },
                setOpen: () => {
                    handleOpen();
                },
                setReason: (message: string) => {
                    setReason(message);
                },
            }),
            [handleOpen, handleClose, setReason]
        );
        return (
            <Box>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    <Box className="container-escalated-modal">
                        <Typography variant="h6" id="parent-modal-title">
                            Some of the checks in this packet were marked as
                            Escalated.
                        </Typography>
                        <Typography variant="h6" id="parent-modal-title">
                            See the below comments:
                        </Typography>
                        <Box className="container-escalated-detail">
                            <Typography className="escalated-detail-reason">
                                {reason}
                            </Typography>
                        </Box>
                        <Box className="escalated-solicitor-action">
                            <Formik
                                initialValues={{
                                    smallInput: 'Insert Here',
                                }}
                                enableReinitialize
                                onSubmit={() => {
                                    // console.log('');
                                }}
                            >
                                <Box className="containerButton">
                                    <AppPrimaryButton
                                        title="Leave Cross check"
                                        className="btn-small back-button"
                                        disabled={isActiveBackNavigation}
                                        onClick={() => {
                                            setActiveBackNavigation(true);
                                            navigation(-1);
                                        }}
                                    />
                                    <AppPrimaryButton
                                        title="Proceed"
                                        className="btn-small"
                                        onClick={handleClose}
                                    />
                                </Box>
                            </Formik>
                        </Box>
                    </Box>
                </Modal>
            </Box>
        );
    }
);

export default EscalatedModal;
